import {
  ILayerPerformanceCriteriaImperial,
  LayerPerformanceCriteriaLocation,
  LayerPerformanceCriteriaType
} from "@/modules/perRoad/interfaces/perRoad";
import {UnitSystem} from "@/interfaces/units";

/**
 * Default Performance Criteria
 */

export const createAcHorizontalDistributionPerformanceCriteria = (): ILayerPerformanceCriteriaImperial => ({
  id: null,
  enabled: true,
  unitSystem: UnitSystem.Imperial,
  criteria: LayerPerformanceCriteriaType.STRAIN_HORIZONTAL_DISTRIBUTION,
  deflectionThreshold_in: null,
  stressThreshold_psi: null,
  strainThreshold_ustrain: null,
  targetPercentile: null,
  distributionPercentiles: [95, 85, 75, 65, 55],
  distribution_ustrain: [257, 194, 158, 131, 110],
  useTransferFunction: false,
  location: LayerPerformanceCriteriaLocation.BOTTOM,
  k1: null,
  k2: null,
});

const createSurfaceDeflectionCriteria = (): ILayerPerformanceCriteriaImperial => ({
  id: null,
  enabled: true,
  unitSystem: UnitSystem.Imperial,
  criteria: LayerPerformanceCriteriaType.DEFLECTION_VERTICAL,
  deflectionThreshold_in: 0.0003,
  targetPercentile: 50,
  strainThreshold_ustrain: null,
  stressThreshold_psi: null,
  distributionPercentiles: null,
  distribution_ustrain: null,
  useTransferFunction: false,
  location: LayerPerformanceCriteriaLocation.TOP,
  k1: null,
  k2: null,
});

export const createHorizontalMeDesignCriteria = (): ILayerPerformanceCriteriaImperial => ({
  id: null,
  enabled: true,
  unitSystem: UnitSystem.Imperial,
  criteria: LayerPerformanceCriteriaType.STRAIN_HORIZONTAL,
  deflectionThreshold_in: null,
  targetPercentile: 50,
  strainThreshold_ustrain: 150,
  stressThreshold_psi: null,
  distributionPercentiles: null,
  distribution_ustrain: null,
  useTransferFunction: false,
  location: LayerPerformanceCriteriaLocation.BOTTOM,
  k1: 2.83e-6,
  k2: 3.148,
});

export const createVerticalMeDesignCriteria = (): ILayerPerformanceCriteriaImperial => ({
  id: null,
  enabled: true,
  unitSystem: UnitSystem.Imperial,
  criteria: LayerPerformanceCriteriaType.STRAIN_VERTICAL,
  deflectionThreshold_in: null,
  targetPercentile: 50,
  strainThreshold_ustrain: 200,
  stressThreshold_psi: null,
  distributionPercentiles: null,
  distribution_ustrain: null,
  useTransferFunction: false,
  location: LayerPerformanceCriteriaLocation.BOTTOM,
  k1: 2.83e-6,
  k2: 3.148,
});
